import { render, staticRenderFns } from "./Wp_jd_action_list.vue?vue&type=template&id=0324e039&scoped=true&"
import script from "./Wp_jd_action_list.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_action_list.vue?vue&type=script&lang=js&"
import style0 from "./Wp_jd_action_list.vue?vue&type=style&index=0&id=0324e039&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0324e039",
  null
  
)

export default component.exports